import { pgTable, serial, text, integer, timestamp } from "drizzle-orm/pg-core";

/**
 * Functional Design Document (FDD) generated from a tender's uploaded
 * documents. One row per tender (the latest generation overwrites).
 */
export const tenderFddsTable = pgTable("tender_fdds", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull().unique(),
  language: text("language", { enum: ["ar", "en"] }).notNull().default("ar"),
  overview: text("overview"),
  functionalRequirements: text("functional_requirements"),
  nonFunctionalRequirements: text("non_functional_requirements"),
  dataRequirements: text("data_requirements"),
  interfaces: text("interfaces"),
  constraints: text("constraints"),
  assumptions: text("assumptions"),
  acceptanceCriteria: text("acceptance_criteria"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export type TenderFdd = typeof tenderFddsTable.$inferSelect;
